// /* 
// import { throwError as observableThrowError } from 'rxjs';

// import { catchError, map } from 'rxjs/operators';
// import { Component, Input, Output, EventEmitter } from '@angular/core';
// import { HttpClient, HttpHeaders } from '@angular/common/http';

// import { ConfigurationService } from '../core/configuration.service';

// @Component({
//   selector: 'tv-upload-file',
//   templateUrl: './upload.file.component.html',
//   styleUrls: ['./upload.file.component.css']
// })
// export class UploadFileComponent {
//   @Input() public uploadedFile: any;
//   @Input() public correlationId: number;

//   @Output() public FileUploadSuccess: EventEmitter<any> = new EventEmitter<any>();
//   @Output() public FileUploadFailure: EventEmitter<any> = new EventEmitter<any>();

//   constructor(private httpClient: HttpClient, private configurationService: ConfigurationService) {
//   }

//   public fileChange(fileChangeEvent): void {
//     const fileList: FileList = fileChangeEvent.target.files;

//     if (fileList.length > 0) {
//       const file: File = fileList[0];
//       const formData: FormData = new FormData();
//       formData.append('uploadFile', file, file.name);

//       const headers = new HttpHeaders();
//       headers.append('Content-Type', 'multipart/form-data');
//       headers.append('Accept', 'application/json');

//       this.httpClient.post(this.configurationService.BaseUploadUrl + 'image', formData, { headers: headers }).pipe(
//         map(res => {
//           console.log('Response for upload is', res);
//           this.FileUploadSuccess.emit({
//             error: null,
//             path: res,
//             correlationId: this.correlationId
//           });
//           this.uploadedFile = this.configurationService.BaseUrl + res;
//         }),
//         catchError(error => {
//           console.log('Failed to upload file ', error);
//           this.FileUploadFailure.emit({
//             error,
//             path: null,
//             correlationId: this.correlationId
//           });
//           return observableThrowError(error);
//         }))
//         .subscribe(data => data = null, error => error = null);
//     }
//   }
// }
//  */



// import { throwError as observableThrowError } from 'rxjs';

// import { catchError, map } from 'rxjs/operators';
// import { Component, Input, Output, EventEmitter } from '@angular/core';
// import { HttpClient, HttpHeaders } from '@angular/common/http';

// import { ConfigurationService } from '../core/configuration.service';
// import { DomSanitizer } from '@angular/platform-browser';

// @Component({
//   selector: 'tv-upload-file',
//   templateUrl: './upload.file.component.html',
//   styleUrls: ['./upload.file.component.css']
// })
// export class UploadFileComponent {
//   @Input() public uploadedFile: any;
//   @Input() public correlationId: number;
//   public imagePath;
//   imgURL: any;
//   public message: string;
//   public previewImage: any[] = [];
//   public fileCount: number = 0;
//   showPreviewImage: boolean = false;

//   @Output() public FileUploadSuccess: EventEmitter<any> = new EventEmitter<any>();
//   @Output() public FileUploadFailure: EventEmitter<any> = new EventEmitter<any>();

//   constructor(private httpClient: HttpClient, private configurationService: ConfigurationService,
//     private sanitizer: DomSanitizer) {
//   }




//   preview(files) {
//     if (files.length === 0)
//       return;
//     this.fileCount = files.length;
//     this.previewImage=[];
//     this.showPreviewImage=false;
//     for (let i = 0; i < files.length; i++) {
//       this.upload(i, files[i]);
//     }
//   }
//   upload(count: number, files) {

//     var mimeType = files.type;
//     if (mimeType.match(/image\/*/) == null) {
//       this.message = "Only images are supported.";
//       return;
//     }
//     this.imagePath = files;
//     var reader = new FileReader();
//     reader.readAsDataURL(files);
//     reader.onload = (_event) => {
//       this.imgURL = reader.result;
//       this.previewImage.push(this.imgURL);
//       //console.log('this.imGurl = ', this.previewImage);
//       //console.log('this.imGurl type = ', typeof this.imgURL);

//       const file: File = files;
//       const formData: FormData = new FormData();
//       formData.append('uploadFile', file, file.name);
//       const headers = new HttpHeaders();
//       headers.append('Content-Type', 'multipart/form-data');
//       headers.append('Accept', 'application/json');

//       this.httpClient.post(this.configurationService.BaseUploadUrl + 'image', formData, { headers: headers }).pipe(
//         map(res => {
//           console.log('Response for upload is', res);
//           this.FileUploadSuccess.emit({
//             error: null,
//             path: res,
//             correlationId: this.correlationId
//           });
//           // this.uploadedFile= 'data:image/jpeg;base64,' + res;
//           // this.uploadedFile = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${res}`);
//           this.uploadedFile = this.configurationService.BaseUrl + res;
//           if (count + 1 == this.fileCount) {
//             this.showPreviewImage = true;
//           }
//         }),
//         catchError(error => {
//           console.log('Failed to upload file ', error);
//           this.FileUploadFailure.emit({
//             error,
//             path: null,
//             correlationId: this.correlationId
//           });
//           if (count + 1 == this.fileCount) {
//             this.showPreviewImage = true;
//           }
//           return observableThrowError(error);
//         }))
//         .subscribe(data => data = null, error => error = null);

//     }
//   }

//   /* public fileChange(fileChangeEvent): void {
//     const fileList: FileList = fileChangeEvent.target.files;
//     var myReader:FileReader = new FileReader();

//     if (fileList.length > 0) {
//       const file: File = fileList[0];
//       const formData: FormData = new FormData();
//       formData.append('uploadFile', file, file.name);

//       const headers = new HttpHeaders();
//       headers.append('Content-Type', 'multipart/form-data');
//       headers.append('Accept', 'application/json');

//       this.httpClient.post(this.configurationService.BaseUploadUrl + 'image', formData, { headers: headers }).pipe(
//         map(res => {
//           console.log('Response for upload is', res);
//           this.FileUploadSuccess.emit({
//             error: null,
//             path: res,
//             correlationId: this.correlationId
//           });
//          // this.uploadedFile= 'data:image/jpeg;base64,' + res;
//         // this.uploadedFile = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${res}`);
//           this.uploadedFile = this.configurationService.BaseUrl + res;
          
//         }),
//         catchError(error => {
//           console.log('Failed to upload file ', error);
//           this.FileUploadFailure.emit({
//             error,
//             path: null,
//             correlationId: this.correlationId
//           });
//           return observableThrowError(error);
//         }))
//         .subscribe(data => data = null, error => error = null);
//     }
//   } */
// }



import { throwError as observableThrowError } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigurationService } from '../core/configuration.service';

@Component({
  selector: 'tv-upload-file',
  templateUrl: './upload.file.component.html',
  styleUrls: ['./upload.file.component.css']
})
export class UploadFileComponent {
  @Input() public uploadedFile: any;
  @Input() public correlationId: number;

  @Output() public FileUploadSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() public FileUploadFailure: EventEmitter<any> = new EventEmitter<any>();

  constructor(private httpClient: HttpClient, private configurationService: ConfigurationService) {
  }

  public fileChange(fileChangeEvent): void {
    const fileList: FileList = fileChangeEvent.target.files;

    var reader = new FileReader();
   // this.imagePath = fileList;
    reader.readAsDataURL(fileList[0]); 
    reader.onload = (_event) => { 
      console.log(reader.result); 
     // console.log('this.imGurl = ', this.imgURL);
      //console.log('this.imGurl type = ', typeof this.imgURL);
    }

    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);

      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      this.httpClient.post(this.configurationService.BaseUploadUrl + 'image', formData, { headers: headers }).pipe(
        map(res => {
          console.log('Response for upload is', res);
          this.FileUploadSuccess.emit({
            error: null,
            path: res,
            correlationId: this.correlationId
          });
          console.log('reader.result',reader.result);
        //  this.uploadedFile = this.configurationService.BaseUrl + res;
         this.uploadedFile = reader.result;
        }),
        catchError(error => {
          console.log('Failed to upload file ', error);
          this.FileUploadFailure.emit({
            error,
            path: null,
            correlationId: this.correlationId
          });
          return observableThrowError(error);
        }))
        .subscribe(data => data = null, error => error = null);
    }
  }
}
 
 
 /*
 
import { throwError as observableThrowError } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigurationService } from '../core/configuration.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'tv-upload-file',
  templateUrl: './upload.file.component.html',
  styleUrls: ['./upload.file.component.css']
})
export class UploadFileComponent {
  @Input() public uploadedFile: any;
  @Input() public correlationId: number;
  public imagePath;
  imgURL: any;
  public message: string;

  @Output() public FileUploadSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() public FileUploadFailure: EventEmitter<any> = new EventEmitter<any>();

  constructor(private httpClient: HttpClient, private configurationService: ConfigurationService,
    private sanitizer: DomSanitizer) {
  }



 
  preview(files) {
    if (files.length === 0)
      return;
    
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/
      /*) == null) {
      this.message = "Only images are supported.";
      return;
    }
 
    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]); 
    reader.onload = (_event) => { 
      this.imgURL = reader.result; 
      console.log('this.imGurl = ', this.imgURL);
      console.log('this.imGurl type = ', typeof this.imgURL);



      const file: File = files[0];
      const formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      this.httpClient.post(this.configurationService.BaseUploadUrl + 'image', formData, { headers: headers }).pipe(
        map(res => {
          console.log('Response for upload is', res);
          this.FileUploadSuccess.emit({
            error: null,
            path: res,
            correlationId: this.correlationId
          });
         // this.uploadedFile= 'data:image/jpeg;base64,' + res;
        // this.uploadedFile = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${res}`);
          this.uploadedFile = this.configurationService.BaseUrl + res;
          
        }),
        catchError(error => {
          console.log('Failed to upload file ', error);
          this.FileUploadFailure.emit({
            error,
            path: null,
            correlationId: this.correlationId
          });
          return observableThrowError(error);
        }))
        .subscribe(data => data = null, error => error = null);

    }
  }

  /* public fileChange(fileChangeEvent): void {
    const fileList: FileList = fileChangeEvent.target.files;
    var myReader:FileReader = new FileReader();

    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);

      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      this.httpClient.post(this.configurationService.BaseUploadUrl + 'image', formData, { headers: headers }).pipe(
        map(res => {
          console.log('Response for upload is', res);
          this.FileUploadSuccess.emit({
            error: null,
            path: res,
            correlationId: this.correlationId
          });
         // this.uploadedFile= 'data:image/jpeg;base64,' + res;
        // this.uploadedFile = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${res}`);
          this.uploadedFile = this.configurationService.BaseUrl + res;
          
        }),
        catchError(error => {
          console.log('Failed to upload file ', error);
          this.FileUploadFailure.emit({
            error,
            path: null,
            correlationId: this.correlationId
          });
          return observableThrowError(error);
        }))
        .subscribe(data => data = null, error => error = null);
    }
  } 
}*/
